/**
 * Widget de notificaciones del dashboard (HU-012) — pila fija arriba a la
 * derecha, cada notificación se autodestruye sola (el temporizador lo arma
 * quien la crea, acá solo se pinta la lista actual). Pensado para avisar de
 * incidencias nuevas detectadas por polling (`AlertasDelDia.jsx`) sin
 * depender de recargar la página ni de WebSockets — no hay esa
 * infraestructura hoy, y agregarla para esto sería sobredimensionado.
 */
const ToastNotificaciones = ({ notificaciones, onDescartar }) => {
  if (notificaciones.length === 0) return null;
  return (
    <div className="panel-toast-contenedor">
      {notificaciones.map((n) => (
        <div key={n.id} className="panel-toast" onClick={() => onDescartar(n.id)}>
          <i className="fas fa-triangle-exclamation panel-toast-icono"></i>
          <div>
            <strong>Nueva incidencia</strong>
            <p>{n.texto}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastNotificaciones;
